import React, { useState, useEffect, useRef } from 'react';
import './Documents.css';
import DocumentsTable from './components/DocumentsTable';
import UserDocumentHeader from './components/UserDocumentHeader';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';

const Document = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('Document - Received paymentScenario:', paymentScenario);

  // Use constants instead of hardcoded logic
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('Document activeData:', activeData);
  console.log('Document scenarioPrefix:', scenarioPrefix);

  // State for toggles - matching Dashboard pattern
  const [toggles, setToggles] = useState({
    documentHeader: true,
    documentTable: true,
  });

  const [templates, setTemplates] = useState([]);
  const [blockStates, setBlockStates] = useState({});
  const [documentBlockStates, setDocumentBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  // Template name logic with scenario prefix - matching Dashboard pattern
  const template_name = scenarioPrefix === 'current-payment' 
    ? 'gardenwall-document' 
    : `gardenwall-document-${scenarioPrefix}`;
    
  console.log('Document Template name:', template_name);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  const handleDocumentBlockStatesChange = (newBlockStates) => {
    setDocumentBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches - matching Dashboard
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  // Auto-save trigger - matching Dashboard pattern
  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates, documentBlockStates]);

  // Fetch templates function - matching Dashboard
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount - matching Dashboard
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  // Reload templates effect - matching Dashboard
  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };
  
      loadTemplates();
    }
  }, [reloadTemplates]);

  // Apply template data when templates are loaded - matching Dashboard
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('Document Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(template_data.toggles || {
            documentHeader: true,
            documentTable: true,
          });
          setBlockStates(template_data.blockStates || {});
          setDocumentBlockStates(template_data.documentBlockStates || {});
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('Document specific template not found');
      }
    }
  }, [templates, template_name]);

  // Save data function - matching Dashboard pattern
  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        documentBlockStates,
        scenarioData: paymentScenario
      })
    );
    
    console.log('Document - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('Document Response Data:', response.data); 
      if (method === 'post') {
        setReloadTemplates(true);
      }

    } catch (error) {
      console.error('Error saving document template:', error);
    }
  };

  return (
    <div className="document">
      <div className="document-main">
        {/* Document Header with Payment Scenario Status */}
        <h1 className="document-header">
          Documents – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
        </h1>

        <div className="document-grid">
          {/* Document Header Card */}
          <div className={`card col-4 get-document ${!toggles.documentHeader ? 'card-disabled' : ''}`}>
            <div className="card-header">
              Document Header
              <div className="custom-toggle" onClick={() => handleToggle('documentHeader')}>
                <input type="checkbox" checked={toggles.documentHeader} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <UserDocumentHeader 
              scenarioData={paymentScenario}
              onBlockStatesChange={handleBlockStatesChange}
              blockStates={blockStates}
            />
          </div>

          {/* Document Table Card */}
          <div className={`card col-4 get-document ${!toggles.documentTable ? 'card-disabled' : ''}`}>
            <div className="card-header">
              Document Table
              <div className="custom-toggle" onClick={() => handleToggle('documentTable')}>
                <input type="checkbox" checked={toggles.documentTable} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <DocumentsTable 
              scenarioData={paymentScenario}
              onDocumentBlockStatesChange={handleDocumentBlockStatesChange}
              documentBlockStates={documentBlockStates}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Document;

